// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './content-card.module.scss';
import { ContentCardProps } from './content-card-props.interface';

/**
 * Display a content card
 * @param props the component props
 */
const UserAccessContentCard = (props: ContentCardProps): ReactElement => {
  const { children, className, ...rest } = props;
  return (
    <div className={clsx(styles.card, className)} {...rest}>
      {children}
    </div>
  );
};

export default UserAccessContentCard;
